export default __webpack_public_path__ + "static/media/amexpng.85151f05.png";